var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9738 1.5H5.02457C3.14783 1.5 1.62109 3.02674 1.62109 4.90421V12.0958C1.62109 13.9725 3.14783 15.5 5.02457 15.5H10.9738C12.8506 15.5 14.378 13.9725 14.378 12.0958V4.90421C14.378 3.02674 12.8506 1.5 10.9738 1.5Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4371 6.91093H5.55849C5.25344 6.91093 5.00586 6.66335 5.00586 6.3583C5.00586 6.05324 5.25344 5.80566 5.55849 5.80566H10.4371C10.7422 5.80566 10.9897 6.05324 10.9897 6.3583C10.9897 6.66335 10.7422 6.91093 10.4371 6.91093ZM7.84858 10.3815H5.55849C5.25344 10.3815 5.00586 10.1339 5.00586 9.82886C5.00586 9.52381 5.25344 9.27623 5.55849 9.27623H7.84858C8.15363 9.27623 8.40121 9.52381 8.40121 9.82886C8.40121 10.1339 8.15363 10.3815 7.84858 10.3815Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressDetails);
export default __webpack_public_path__ + "static/media/address_details.0d7bff56.svg";
export { ForwardRef as ReactComponent };